import {React, Component, _} from 'utils';
import PropTypes from 'prop-types';
import './filterokbutton.less';

export default class FilterOkButton extends Component {

	render()
	{
		return (
			<div className="sticky-bottom">
				<button className="btn btn-success btn-lg successButton" onClick={ this.props.onClick }>
					{_('Ok')}
				</button>
			</div>
		)
	}
}

FilterOkButton.propTypes = {
	onClick: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/modules/components/elements/filterokbutton.js